/* eslint-disable lines-between-class-members */
// eslint-disable-next-line max-classes-per-file
import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { Insured } from "src/shared/models/insured.model";
import { PolicyProduct } from "src/shared/models/policy-product.model";
import { PaymentSummary } from "src/shared/models/payment-summary.model"; // be careful of circular dependencies
import { DayjsUtils } from "src/libs/dayjs-utils";

enum InsuredRole {
    Contractor = "CONTRACTOR",
    Holder = "TITULAR",
}

export class PgaPolicy extends BaseModel {
    get longId() {
        return `${this.product.systemCode}-${this.id || this.number}`;
    }

    get longProductCode() {
        return `${this.product.systemCode}-${this.product.code}`;
    }

    get isFuture() {
        return DayjsUtils.isFuture(this.validityStart);
    }

    get isContractor() {
        return this.insuredRole === InsuredRole.Contractor;
    }

    @Expose() id = 0;
    @Expose() number = 0;
    /**  @deprecated This class does not include this field anymore. It should be taken from the PgaPolicyDetail model.  */
    @Expose() currency = "";
    // NOTE: Legacy field. Currently we use "role" for data that comes from "/seguros"
    @Expose() insuredRole = "";
    @Expose() role = "";
    @Expose() validityStart = "";
    @Expose() validityEnd = "";
    @Expose() status?: string | undefined;
    @Expose() insureds?: Insured[] | undefined;
    @Expose() insuredCode?: number | undefined;
    @Expose()
    @Type(() => PolicyProduct)
    product: PolicyProduct = new PolicyProduct();
    @Expose()
    @Type(() => PaymentSummary)
    paymentSummary?: PaymentSummary | undefined;
}
